import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "login",
  "use": "login-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"login\"><path d=\"M11 5h8v14h-8v2h8c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-8zm.17 6L8.59 8.41 10 7l5 5-5 5-1.41-1.41L11.17 13H3v-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol